import { formatGel } from '@/utils/money';
import type { ImportRow } from '../../importRows';
import { formatQuantity } from '../importTable/importTableMeta';

/**
 * A card's height before it is measured, for the virtualizer's first layout:
 * a row with a match chip and no note at 390 px (the row line with its
 * button, name, SKU, figures, match chip and the paddings; 165 px measured
 * in Georgian). Each card is measured once it renders, and again when its
 * row changes, so a note or a wrapped name only corrects the estimate.
 */
export const IMPORT_CARD_ESTIMATED_HEIGHT_PX = 168;

/** What a card shows for a blank amount, as the app's other read-only figures do. */
export const BLANK_FIGURE = '—';

/**
 * A card's figures line, in order: quantity, cost and sale price, each with
 * its label and its value as the card shows it (money with its symbol, as no
 * column header carries ₾ on a card; `—` when blank). `testId` keeps the
 * table's cell ids.
 */
export const IMPORT_CARD_FIGURES = [
    {
        testId: 'quantity',
        labelKey: 'catalogImport.products.card.quantity',
        valueOf: (row: ImportRow): string =>
            row.quantity === null ? BLANK_FIGURE : formatQuantity(row.quantity),
    },
    {
        testId: 'cost',
        labelKey: 'catalogImport.products.card.cost',
        valueOf: (row: ImportRow): string =>
            row.costTetri === null ? BLANK_FIGURE : formatGel(row.costTetri),
    },
    {
        testId: 'sale-price',
        labelKey: 'catalogImport.products.card.salePrice',
        valueOf: (row: ImportRow): string =>
            row.salePriceTetri === null
                ? BLANK_FIGURE
                : formatGel(row.salePriceTetri),
    },
] as const;
